/** InsCoder 2026-07-01 B + EF-Wib_1 mobile dropdown **/
(function () {
  'use strict';

  function initWibSection(mobileRoot) {
    if (!mobileRoot || mobileRoot.getAttribute('data-ef-wib-1-initialized') === 'true') {
      return;
    }

    var dropdown = mobileRoot.querySelector('[data-ef-wib-1-dropdown]');
    var trigger = dropdown && dropdown.querySelector('[data-ef-wib-1-trigger]');
    var menu = dropdown && dropdown.querySelector('[data-ef-wib-1-menu]');
    var label = dropdown && dropdown.querySelector('[data-ef-wib-1-label]');
    var panels = mobileRoot.querySelectorAll('[data-ef-wib-1-panel]');

    if (!dropdown || !trigger || !menu || !label) {
      return;
    }

    mobileRoot.setAttribute('data-ef-wib-1-initialized', 'true');

    function closeMenu() {
      dropdown.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.setAttribute('hidden', '');
    }

    function openMenu() {
      dropdown.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      menu.removeAttribute('hidden');
    }

    function selectBundle(index, name) {
      label.textContent = name;

      dropdown.querySelectorAll('.ef-wib-1__dropdown-option').forEach(function (opt) {
        var isActive = opt.getAttribute('data-bundle-index') === String(index);
        opt.classList.toggle('is-active', isActive);
        opt.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-bundle-index') === String(index);
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      closeMenu();
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (dropdown.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    menu.addEventListener('click', function (e) {
      var option = e.target.closest('.ef-wib-1__dropdown-option');
      if (!option) return;
      e.preventDefault();
      e.stopPropagation();
      selectBundle(
        option.getAttribute('data-bundle-index'),
        option.getAttribute('data-bundle-name') || option.textContent.trim()
      );
    });

    document.addEventListener('click', function (e) {
      if (!dropdown.contains(e.target)) {
        closeMenu();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeMenu();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-ef-wib-1-mobile]').forEach(initWibSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var mobileRoot = event.target.querySelector('[data-ef-wib-1-mobile]');
    if (mobileRoot) {
      initWibSection(mobileRoot);
    }
  });
})();
/** InsCoder 2026-07-01 E + EF-Wib_1 mobile dropdown **/
